<template>
  <div class="buy-detail-page">
    <div class="card-info">
      <div class="name-wrapper">
        <img src="@/images/member/member-icon.png" class="member-icon" />
        <div class="card-name">
          <div class="name">{{ typeDesc }}</div>
          <div :class="['status', 'status' + status]">
            {{ statusName }}
          </div>
        </div>
      </div>
      <div v-for="(item, index) in priceList" :key="index" class="price-item">
        <div class="left">{{ item.name }}</div>
        <div
          :class="['right', item.key === 'originalPrice' ? 'origin-price' : '']"
        >
          {{ item.value }}
        </div>
      </div>
    </div>
    <div class="order-info">
      <div v-for="(item, index) in orderInfo" :key="index" class="item">
        <div class="order-name">{{ item.name }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
    <p class="desc-text">
      由于不同时间不同区域的会员卡购买活动优惠力度不同，最终以实际支付金额为准。
    </p>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import { API } from '@/api'
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '购买详情'
      navBar.setTitle({
        text: '购买详情'
      })
      const orderId = to.query.orderId
      vm.getOrderDetail(orderId)
    })
  },
  data() {
    return {
      priceList: [],
      orderInfo: [],
      typeDesc: '',
      statusName: ''
    }
  },
  methods: {
    async getOrderDetail(orderId) {
      const resData = await API.primeCard.primeCardOrderDetail({ orderId })
      this.priceList = resData.price || []
      this.orderInfo = resData.order || []
      this.typeDesc = resData.typeDesc || ''
      this.statusName = resData.statusName || ''
      this.status = resData.status
    }
  }
}
</script>
<style lang="scss" scoped>
.buy-detail-page {
  height: 100vh;
  padding: 0.16rem 0.24rem;

  background-color: #f5f5f5;
  .card-info,
  .order-info {
    padding: 0.24rem;

    background-color: #fff;

    border-radius: 0.24rem;
  }
  .card-info {
    .name-wrapper {
      margin-bottom: 0.2rem;
      @include flex(row, normal, center);
      .member-icon {
        width: 0.96rem;
        height: 0.96rem;
        margin-right: 0.16rem;
      }
      .card-name {
        .name {
          font-size: 0.32rem;
          font-weight: bold;
          color: #262626;
        }
        .status {
          margin-top: 0.08rem;

          font-size: 0.26rem;
          &.status2 {
            color: #15bb5c;
          }
          &.status3 {
            color: #8c8c8c;
          }
          &.status4 {
            color: #ff9d21;
          }
        }
      }
    }
    .price-item {
      margin-bottom: 0.16rem;

      font-size: 0.28rem;
      line-height: 0.4rem;
      @include flex-row-between;
      &:last-child {
        margin-bottom: 0;
      }
      .left {
        color: #8c8c8c;
      }
      .right {
        font-weight: bold;
        color: #f03100;
        &.origin-price {
          color: #262626;
        }
      }
    }
  }
  .order-info {
    margin-top: 0.16rem;
    .item {
      margin-bottom: 0.16rem;

      font-size: 0.28rem;
      line-height: 0.4rem;
      @include flex-row-between;
      &:last-child {
        margin-bottom: 0;
      }
      .order-name {
        color: #8c8c8c;
      }
      .value {
        color: #262626;
      }
    }
  }
  .desc-text {
    margin-top: 0.16rem;

    line-height: 18px;
    @include text(0.24rem, #8c8c8c);
  }
}
</style>
